import { Modal, Divider, Typography } from 'antd';
import { Button } from '../../../../../../../components/button';
import style from './style.module.scss';
import {
    Client,
    ClientExternalDetails,
} from '../../../../../../../stores/client';

const { Text } = Typography;

interface ConfirmationDialogProps {
    client1: Client | null;
    client2: ClientExternalDetails | null;
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialogComponent = ({
    client1,
    client2,
    open,
    onConfirm,
    onCancel,
}: ConfirmationDialogProps) => {
    return (
        <Modal
            title="Confirm Swap"
            open={open}
            onOk={onConfirm}
            onCancel={onCancel}
            okText="Confirm"
            className={style.modal}
            footer={[
                <Button key="confirm" variant="primary" onClick={onConfirm}>
                    Confirm
                </Button>,
            ]}
        >
            <div className={style.container}>
                <div className={style.box}>
                    <Text className={style.clientId}>Client {client1?.id}</Text>
                    <p>
                        <Text className={style.label}>Customer ID:</Text>{' '}
                        {client1?.ngrpCustomerId}
                    </p>
                    <p>
                        <Text className={style.label}>Liquid Barcode ID:</Text>{' '}
                        {client1?.liquidBarcodeId}
                    </p>
                </div>
                <Divider>Swap with</Divider>
                <div className={style.box}>
                    <Text className={style.clientId}>Client {client2?.id}</Text>
                    <p>
                        <Text className={style.label}>Customer ID:</Text>{' '}
                        {client2?.ngrpCustomerId}
                    </p>
                    <p>
                        <Text className={style.label}>Liquid Barcode ID:</Text>{' '}
                        {client2?.liquidBarcodeId}
                    </p>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmationDialogComponent;
